import React from 'react'

export default function Door() {
    return (
        <div>
            <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M24.75 47.25H42.75V42.75L45 40.5V49.5H24.75V54L2.25 47.25V6.75L24.75 0V4.5H45V15.75L42.75 13.5V6.75H24.75V47.25ZM47.3692 27L39.96 19.5907L41.5507 18L51.6757 28.125L41.5507 38.25L39.96 36.6592L47.3692 29.25H27V27H47.3692Z" fill="#BB0600" />
            </svg>

        </div>
    )
}
